import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ZteLogo from './assets/logo-ZTE.svg?react';
import LazeLogo from './assets/logo-LAZE.svg?react';

const LogoWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100vh;
    margin: 0 8%;
    align-items: center;
`;

const ClassworkPreview = ({ assignment, assignmentId, getAssignmentById }) => {
    const isZTE = window.location.host.split('.')[0].includes('zte');

    useEffect(() => {
        let title = isZTE ? 'ZTE Zanichelli' : 'laZ Esercizi';
        if (assignment?.bookInfo) {
            title = assignment.bookInfo.bookTitle;
        }
        document.title = title;
    }, [assignment, isZTE]);

    useEffect(() => {
        getAssignmentById(assignmentId);
    }, [assignmentId, getAssignmentById]);

    return <LogoWrapper>{isZTE ? <ZteLogo /> : <LazeLogo />}</LogoWrapper>;
};

ClassworkPreview.propTypes = {
    assignment: PropTypes.object,
    assignmentId: PropTypes.string,
    getAssignmentById: PropTypes.func,
};

export default ClassworkPreview;
